export const TABLE_VARIABLE_NODE_INDEX_COL_PROPERTY = '__indexCol'
export const TABLE_VARIABLE_NODE_INDEX_COL_TEXT = '序号'
